import axiosInstance from './axiosInstance';

const getChapters = async ({ bookCode, token }) => {
  try {
    const response = await axiosInstance.post(
      '/chapters',
      { bookCode },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export { getChapters };
